// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"u--z","disabled":"v--z","label":"w--z"};